import PageSection from "@components/PageSection";
import React from "react";
import { RelatedTopic } from "@typed/relatedTopic";
import { Link } from "gatsby";


const RelatedTopicsSection = ({ relatedTopics }:{relatedTopics: RelatedTopic[]} ) => {
    const filters = [`primary`, `secondary`, `alternative`];


  
return  (
 
    <PageSection sectionName="Related Topics" >
      <div>
        {filters.map((filter) => {
    
          const filteredTopics = relatedTopics
            .filter((cat) => (cat.connection?.trim().toLowerCase() ?? "primary") === filter)
            .sort((a,b) => a.name.localeCompare(b.name));  

          if(filteredTopics.length === 0) return null;

          return(
              
                  <ul className="pl-2 pb-2 list-inside list-disc marker:text-slate-500">
                      {filteredTopics.map((cat) => (
                        <li key={cat.slug} >
                          <Link to={`/howto/${cat.slug}`} className="underline">
                            {cat.name}
                          </Link>
                        
                          {  cat.connection && cat.connection.trim().toLowerCase() !== `primary` ? ` - ${cat.connection}` : `` }

                          { cat.description && cat.description !== ``? ` - ${cat.description}` : `` }
                        </li>
                      ))}
                  </ul>
                 
          );
        })}

          </div>
   

  </PageSection>
)};

export default RelatedTopicsSection;